import { render } from "./About.vue?vue&type=template&id=70cb9234"
const script = {}
script.render = render

export default script